import React from "react"
import { useReactiveVar } from "@apollo/client"
import { selectedDayVar } from "cache"
import { DateTime } from "luxon"
import { calendarDateRange } from "shared/helpers/calendarDateRange"
import { formatToDayStartISO } from "shared/formatting/datetime"
import PropTypes from "prop-types"

import styles from "./ParkingSelection.module.scss"

const DateNavigation = ({ onCartStartTimeChange, timezone }) => {
  const selectedDay = useReactiveVar(selectedDayVar)
  const setSelectedDay = selectedDayVar
  const { minDate, maxDate } = calendarDateRange()
  const formatMinDate = DateTime.fromISO(minDate, { zone: timezone })
  const formatMaxDate = DateTime.fromISO(maxDate, { zone: timezone })
  const formatSelectedDay = DateTime.fromISO(selectedDay, { zone: timezone })

  const isOnMinDate = formatSelectedDay.hasSame(formatMinDate, "day")
  const isOnMaxDate = formatSelectedDay.hasSame(formatMaxDate, "day")

  // This function will set the selected day to the previous day
  // if the selected day is not the current day
  const handlePreviousDayClick = () => {
    const previousDay = DateTime.fromISO(selectedDay, { zone: timezone }).minus(
      {
        days: 1
      }
    )
    const formatedDate = formatToDayStartISO(previousDay, { timezone })

    setSelectedDay(formatedDate)
    onCartStartTimeChange(formatedDate)
  }

  // This function will set the selected day to the next day
  const handleNextDayClick = () => {
    const nextDay = DateTime.fromISO(selectedDay, { zone: timezone }).plus({
      days: 1
    })
    const formatedDate = formatToDayStartISO(nextDay, { timezone })

    setSelectedDay(formatedDate)
    onCartStartTimeChange(formatedDate)
  }

  return (
    <div className={styles.changeDay}>
      <button
        onClick={handlePreviousDayClick}
        disabled={isOnMinDate} // Disable the button if the selected day is the minimum allowed date
        type="button"
      >
        &lt; Previous Day
      </button>
      <button
        onClick={handleNextDayClick}
        disabled={isOnMaxDate} // Disable the button if the selected day is the maximum allowed date
        type="button"
      >
        Next Day &gt;
      </button>
    </div>
  )
}

DateNavigation.propTypes = {
  timezone: PropTypes.string,
  onCartStartTimeChange: PropTypes.func
}

export default DateNavigation
